/* eslint-disable */

// This is a generated file and SHOULD NOT BE EDITED MANUALLY!!
// Contents are generated as part of grunt build
// Source of truth is lib/cdo/shared_constants.rb and files in lib/cdo/shared_constants/

export const Voices = {
  "en_us": {
    "VOICE": "sharon22k",
    "SPEED": 180,
    "SHAPE": 100
  },
  "es_es": {
    "VOICE": "ines22k",
    "SPEED": 180,
    "SHAPE": 100
  },
  "es_mx": {
    "VOICE": "rosa22k",
    "SPEED": 180,
    "SHAPE": 100
  },
  "it_it": {
    "VOICE": "vittorio22k",
    "SPEED": 180,
    "SHAPE": 100
  },
  "pt_br": {
    "VOICE": "marcia22k",
    "SPEED": 180,
    "SHAPE": 100
  }
};
